export const feriadosFixos = [
  { mes: 0, dia: 1 },   // 01/01 - Confraternização Universal
  { mes: 3, dia: 21 },  // 21/04 - Tiradentes
  { mes: 4, dia: 1 },   // 01/05 - Dia do Trabalhador
  { mes: 8, dia: 7 },   // 07/09 - Independência do Brasil
  { mes: 9, dia: 12 },  // 12/10 - Nossa Senhora Aparecida
  { mes: 10, dia: 2 },  // 02/11 - Finados
  { mes: 10, dia: 15 }, // 15/11 - Proclamação da República
  { mes: 11, dia: 25 }  // 25/12 - Natal
];

export function isFimDeSemana(date: Date): boolean {
  const diaSemana = date.getDay();
  return diaSemana === 0 || diaSemana === 6;
}

export function isFeriadoFixo(date: Date): boolean {
  return feriadosFixos.some(f => f.dia === date.getDate() && f.mes === date.getMonth());
}

export function dataPermitida(date: Date | null): boolean {
  if (!date) return false;
  return !isFimDeSemana(date) && !isFeriadoFixo(date);
}
